// This is pulled from the Account and Wallet dynamic web repo https://github.com/fanduel/aw-dynamic-web/blob/4dcf25802cd75b0ae55a08747c52b8d6dd707e2a/src/common/shared/forms/validators.ts#L32
export const EMAIL_REGEX =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export const validEmail = (value: string) => EMAIL_REGEX.test(value);
